
import { createAction, handleActions } from 'redux-actions';

const setShowOrderModal = createAction("SCREENS/ORDERS/SET_SHOW_ORDER_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowOrderModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowOrderModal, reducer };